import { c as _c } from "react/compiler-runtime";
import { Button, Input } from '@common/components';
import { cn } from '@core/utils';
interface PointUsageSectionProps {
  availablePoints: number;
  usedPoints: number;
  isInsufficient?: boolean;
}
export const PointUsageSection = t0 => {
  const $ = _c(23);
  const {
    availablePoints,
    usedPoints,
    isInsufficient: t1
  } = t0;
  const isInsufficient = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className="font-700 text-Gray-900 typo-h6 mobile-tablet:typo-body2">웰포인트 사용</h2>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== availablePoints) {
    t3 = availablePoints.toLocaleString();
    $[1] = availablePoints;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <div className="mb-4 flex h-48 items-center justify-between">{t2}<span className="text-Gray-600 typo-body2 mobile-tablet:font-600 mobile-tablet:typo-caption1">보유 : {t3}P</span></div>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== usedPoints) {
    t5 = usedPoints.toLocaleString();
    $[5] = usedPoints;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = isInsufficient ? "border-R-400 text-R-400" : "border-O-400 text-O-400";
  let t7;
  if ($[7] !== t6) {
    t7 = cn("flex-1 !rounded-none font-500 typo-body2 mobile-tablet:typo-body4", t6);
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = isInsufficient ? "text-R-400" : "text-O-400";
  let t9;
  if ($[9] !== t8) {
    t9 = cn("font-700", t8);
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t9) {
    t10 = <span className={t9}>P</span>;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t5 || $[15] !== t7) {
    t11 = <Input dimensions="H48" readOnly={true} value={t5} className={t7} rightContent={t10} />;
    $[13] = t10;
    $[14] = t5;
    $[15] = t7;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Button dimensions="H48" theme="sub-line" className="!rounded-none border-Gray-900" disabled={true}>전액 사용</Button>;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t11) {
    t13 = <div className="flex gap-8">{t11}{t12}</div>;
    $[18] = t11;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13 || $[21] !== t4) {
    t14 = <section>{t4}{t13}</section>;
    $[20] = t13;
    $[21] = t4;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  return t14;
};